<template>
    <div @click.prevent="addToCart">
      <div class="icon icon-cart-in" v-if="inCart"></div>
      <div class="icon icon-in-cart" v-else></div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import forEach from '@Utils/forEach'

const { mapActions } = createNamespacedHelpers('cart')

export default {

  props: {
    product: {
      required: true
    }
  },

  data () {
    return {
      qty: this.product.default_qty || 1,
      inCart: false
    }
  },

  created() {
    App.dispatcher.listen('cart.loaded', response => {
        let result = response;
        this.inCart = false;
        forEach(result, (index, el) => {
            if(el.id == this.product.id) {
                this.inCart = true;
            }
        })
    })
  },

  methods: {

    ...mapActions(['addItem']),

    addToCart () {
      this.addItem({
        id: this.product.id,
        qty: this.qty
      })
      this.inCart = true;
    },
  }
}
</script>
